import type { StartContent } from './types';

/**
 * Копия лендинга /start (узбекская, латиница).
 *
 * Правишь текст страницы — правишь этот файл, больше ничего. Вёрстка в
 * routes/landing/, числа приходят из API. Источник: макет
 * docs/superpowers/specs/2026-08-14-landings-mockups/landing-pro-uz.html.
 *
 * pageTitle и heroH1 обязаны оставаться латиницей — encoding-guard.ts валит
 * сборку на кириллице в <title>/<h1> страниц /uz/.
 */
export const startUz: StartContent = {
  kind: 'start',
  pageTitle: "UzTender Pro — buyurtmachilar kontaktlari, hujjatlar va g'oliblar narxi",
  metaDescription:
    "O'zbekiston tenderlari katalogi — bepul. Pro buyurtmachilar kontaktlarini, TT va shartnomalarni, 2023-yildan beri g'oliblar narxlarini hamda Jahon banki tenderlarini ochadi. Yangi tenderlar Telegram'ga e'lon kunida keladi.",
  nav: [
    { label: 'Katalog', href: '/catalog' },
    { label: 'Natijalar', href: '/results' },
    { label: 'Narxlar', href: '/prices' },
    { label: 'XMI', href: '/ifi' },
  ],
  heroKicker: 'Tenderlarda allaqachon qatnashayotgan kompaniyalar uchun',
  heroH1: "O'zbekistonning barcha tenderlari — bitta katalogda",
  heroLead:
    "Tenderlar 35 dan ortiq turli maydonchada e'lon qilinadi — biz hammasini yig'amiz va sizga mosini e'lon kuniyoq Telegramga yuboramiz. Pro'da: buyurtmachi kontaktlari, shartnomali TZ va o'xshash xaridlar g'oliblarining narxlari.",
  // Отступление 10: см. start.ru.ts — barcha CTA, «Tariflar» blokidagi
  // tugmalardan tashqari, /catalog'ga olib boradi.
  ctaPrimary: "Maydonchaga o'tish",
  ctaHeader: "Maydonchaga o'tish",
  // Ikkinchi tugma endi katalogga takror havola emas — #pricing'ga yo'naltirildi.
  ctaSecondary: "Tariflarni ko'rish",
  heroMicro:
    "Katalog bepul, ro'yxatdan o'tish shart emas. To'lov — faqat ishtirok vositalari uchun.",
  sourcesLabel: "Agar tender bizda bo'lmasa — u hech qayerda yo'q:",
  sources: [
    'xarid.uzex.uz',
    'etender.uzex.uz',
    'xt-xarid.uz',
    'Jahon banki',
    'ADB',
    'UNGM',
    'BMTTD',
    'AIIB',
  ],
  // Отступление 7: см. start.ru.ts — N sourceCount'dan serverda hisoblanadi.
  sourcesMoreLabel: 'yana {count} ta maydoncha',
  sourcesUpdateNote: '· har 2 soatda yangilaymiz',
  counters: {
    activeLabel: 'hozir ochiq tenderlar',
    // Отступление 9: счётчик — последние 7 полных календарных дней (UTC), не
    // один день и не скользящее окно; см. start.ru.ts.
    newLastWeekLabel: "bir haftada qo'shildi",
    // Отступление 1: 2016 → 2023.
    awardedLabel: "g'olib narxi ma'lum bo'lgan yakunlangan tenderlar — 2023-yildan beri",
    participantsLabel: "ishtirokchilar haqidagi yozuvlar — kim kim bilan savdolashishi ko'rinadi",
    ifiLabel: 'Jahon banki, ADB va BMT tenderlari — hozir ochiq',
  },
  // Отступление 11 (2026-08-20): см. start.ru.ts — «1/3» pol/shift bahosi
  // (21,7% pol / 56–88% shift, faqat etender yutuqsiz holatni yozadi).
  // Uzbekcha faylda lotin kasr belgisi saqlanadi (ip.uz.ts bilan bir xil).
  // 2026-08-24: bir qatordan to'liq konversion blokka aylantirildi
  // (raqam + sarlavha + izoh + CTA) — start.ru.ts dagi izohga qarang.
  factBig: '1/3',
  factTitle: "tenderlar g'olibsiz yopiladi",
  factBody:
    "Arizalar yetarli bo'lmasa, buyurtmachi xaridni qaytadan e'lon qiladi. Bunday lotlarni birinchi ko'rgan — deyarli raqobatsiz qatnashadi.",
  factCta: 'Raqobati past lotlarni topish',
  painsTitle: 'Tanishmi?',
  pains: [
    {
      title: "Tenderni topdingiz — muddati o'tib bo'lgan",
      body: "Maydonchalar bir nechta, har kuni tekshirish kerak. Bir kun o'tkazib yubordingizmi — tender ham ketdi.",
    },
    {
      title: "Qanday narx qo'yish noma'lum",
      body: "Baland qo'ysangiz — yutqazasiz. Past qo'ysangiz — yutasiz-u, foydasiz ishlaysiz.",
    },
    {
      title: 'Buyurtmachi kontaktini yarim kun qidirasiz',
      body: "Tanishlar orqali, ma'lumotnomalar orqali. Aslida qo'ng'iroq qilib, ikkita savolni aniqlashtirish kifoya edi.",
    },
  ],
  nicheSectionKicker: "To'lovdan oldin — bepul tekshiring",
  nicheSectionTitle: 'Sizning sohangiz allaqachon katalogda',
  nicheSectionLead: "Hozir faol tenderlari bor jonli bo'limlar. O'zingiznikini ochib ko'ring.",
  moreCategoriesLabel: 'yana 22 ta toifa →',
  regionsLabel: 'Va barcha 14 hudud:',
  regions: [
    { code: 'TSH', label: 'Toshkent shahri' },
    { code: 'TAS', label: 'Toshkent viloyati' },
    { code: 'SAM', label: 'Samarqand' },
    { code: 'FER', label: "Farg'ona" },
    { code: 'AND', label: 'Andijon' },
    { code: 'NAM', label: 'Namangan' },
    { code: 'BUK', label: 'Buxoro' },
    { code: 'KAS', label: 'Qashqadaryo' },
    { code: 'SUR', label: 'Surxondaryo' },
    { code: 'KHO', label: 'Xorazm' },
    { code: 'NAV', label: 'Navoiy' },
    { code: 'JIZ', label: 'Jizzax' },
    { code: 'SIR', label: 'Sirdaryo' },
    { code: 'KAR', label: "Qoraqalpog'iston" },
  ],
  howKicker: 'Bu qanday ishlaydi',
  howTitle: "Pro nimani o'zgartiradi",
  how: [
    {
      title: "Tenderlar o'zi keladi",
      body: "Qidiruvni saqlang — masalan, «qurilish, Namangan». Yangi tenderlar e'lon kuni Telegram'ga keladi. Har kuni ertalab — mavzularingiz bo'yicha bitta dayjest.",
      bullets: [
        "Saqlangan qidiruvlar bo'yicha bildirishnomalar — cheklovsiz",
        "Bot TT bo'yicha savollarga javob beradi",
        "Servis qaysi tenderlarni yutganingizni ko'radi va o'xshashlarini o'zi yuboradi",
      ],
      // Pro-kabinet suratkashligi 13.08.2026 (maket landing-pro-uz.html:371–376).
      illustration: {
        kind: 'chat',
        messages: [
          {
            side: 'in',
            title: "🔔 «Qurilish, Namangan» qidiruvi bo'yicha yangi tender",
            body: "Davlat kadastr palatasi binosini kapital ta'mirlash — 2,2 mlrd so'm, 20-avgustgacha",
            time: '08:12',
          },
          { side: 'out', title: '', body: 'tajribaga qanday talablar bor?', time: '' },
          {
            side: 'in',
            title: 'UzTender',
            body: "TT bo'yicha: o'xshash ishlar tajribasi, qurilish-montaj ishlariga litsenziya, ta'minot 22,07 mln so'm",
            time: '08:13',
          },
        ],
      },
      links: [],
    },
    {
      title: "G'oliblar narxi ko'rinadi",
      // Отступление 1: 2016 → 2023.
      body: "Har bir tenderda bozor ma'lumotlari bor: odatda nechta ishtirokchi keladi va o'xshash xaridlar qaysi narx oralig'ida yutilgan. Bu bashorat emas — 2023-yildan beri yig'ilgan haqiqiy savdolar tarixi.",
      bullets: [
        "Toifangiz bo'yicha g'oliblar narxlari",
        'Bunday savdolarga odatda nechta ishtirokchi keladi',
        'Buyurtmachi kimdan va qanchalik tez-tez xarid qiladi',
      ],
      // Pro-kabinetdan haqiqiy raqamlar: «Yuridik xizmatlar» tenderi, 13.08.2026
      // (maket landing-pro-uz.html:394–403).
      illustration: {
        kind: 'stats',
        title: 'Bu buyurtmachining yetkazib beruvchilari',
        badge: 'Pro-kabinetdan',
        source: "5 ta yetkazib beruvchi · 5 ta shartnoma · 75,3 mln so'm",
        rows: [
          { label: 'Doimiy yetkazib beruvchi', value: '51,1% shartnomalar', strong: true },
          { label: "Hajmi bo'yicha ikkinchisi", value: '29,0%', strong: false },
          { label: 'Qolganlar', value: '19,9%', strong: false },
        ],
        note: "Buyurtmachining «o'z» yetkazib beruvchisi bo'lsa — buni yutqazgandan keyin emas, ariza topshirishdan oldin bilasiz.",
      },
      // Chek-list ostidagi ikkita havola (maket landing-pro-uz.html:390–391) —
      // shu sahifadan /results va /prices'ga yagona kontekstual ichki havolalar.
      links: [
        { label: 'Tender natijalari →', href: '/results' },
        { label: "O'rtacha narxlar →", href: '/prices' },
      ],
    },
    {
      title: "Buyurtmachiga qo'ng'iroq qilish mumkin",
      body: "Ariza topshirishdan oldin, keyin emas. Tenderni ochdingiz — kontakt, TT va shartnoma shu yerda. Bitta qo'ng'iroq savollarning yarmini yechadi va bir haftalik qayta ishlashdan saqlaydi.",
      bullets: [
        'Buyurtmachilar kontaktlari — cheklovsiz',
        "TT va shartnoma — tender kartochkasining o'zida",
        "Excel'ga yuklab olish — smetachi uchun",
      ],
      // Haqiqiy tender: Pro-kabinetdagidek hujjatlar va kontakt (maket
      // landing-pro-uz.html:417–438). Buyurtmachi INN'i ataylab qisqartirilgan
      // — bu pullik kontakt, illyustratsiya uni fosh qilmasligi kerak.
      illustration: {
        kind: 'docs',
        status: 'Faol',
        left: '8 kun qoldi',
        title: 'Boshqa yuridik xizmatlar — Samarqandda davlat mulkini boshqarish',
        categories: ['Moliyaviy va yuridik xizmatlar'],
        rows: [
          { label: 'Byudjet', value: "63,6 mln so'm" },
          { label: 'Kontakt shaxs', value: 'Davlat aktivlarini boshqarish agentligi · STIR 2016…' },
        ],
        docs: ['Texniktopshiriq.pdf', 'Шартнома(ГПД).pdf'],
        steps: [
          "Tenderni ko'rdingiz",
          'TTni ochdingiz',
          "Qo'ng'iroq qildingiz",
          'Ariza topshirdingiz',
        ],
      },
      links: [],
    },
  ],
  // Xirodagi «Bozor ma'lumotlari» paneli (maket landing-pro-uz.html:258–269) —
  // yuqoridagi kartochka bilan bir xil tenderning Pro-kabinet suratkashligi,
  // 13.08.2026.
  heroIllustration: {
    kind: 'range',
    title: "Bozor ma'lumotlari",
    badge: 'Pro-kabinetdan',
    source: "500 ta o'xshash natija asosida",
    cells: [
      { label: 'Ishtirokchilar medianasi', value: '5' },
      { label: 'Mediana chegirma', value: '5%' },
    ],
    rangeLabel: "G'olib narxi diapazoni",
    min: '441,7 mln',
    max: '3,9 mlrd',
    markerPct: 51,
    note: 'bu tender — 2,2 mlrd',
  },
  heroSearchPlaceholder: "Tenderlarni ma'no bo'yicha qidirish…",
  compareTitle: "Nima bepul, nima Pro'da",
  compareLead:
    "Katalog bepul edi va shunday qoladi. Pro — uning ustidagi qo'shimcha: ishtirok vositalari.",
  compareHeadFree: 'Bepul',
  compareHeadPro: 'Pro',
  compareGroups: [
    {
      title: 'Hammaga — abadiy bepul',
      rows: [
        { label: "Barcha tenderlar: summalar, muddatlar, ta'minot", free: '✓', pro: '✓' },
        { label: "O'zbekcha va ruscha tushunarli tavsif", free: '✓', pro: '✓' },
        { label: "Toifalar bo'yicha o'rtacha narxlar", free: '✓', pro: '✓' },
      ],
    },
    {
      title: "Pro'da ochiladi",
      rows: [
        { label: 'Buyurtmachilar kontaktlari', free: '—', pro: 'cheksiz' },
        { label: 'Har bir tender uchun TT va shartnoma', free: '—', pro: '✓' },
        { label: "O'xshash tenderlarni kim va qanday narxda yutgani", free: '—', pro: '✓' },
        {
          label: 'Nechta ishtirokchi kelishi va buyurtmachi kimdan xarid qilishi',
          free: '—',
          pro: '✓',
        },
        { label: 'Jahon banki, ADB va BMT tenderlari', free: '—', pro: '✓' },
        {
          label: "Telegram-bot: bildirishnomalar, dayjestlar, TT bo'yicha javoblar",
          free: '—',
          pro: '✓',
        },
        { label: 'Saqlangan qidiruvlar va bildirishnomalar — cheklovsiz', free: '—', pro: '✓' },
        { label: "Excel'ga yuklab olish", free: '—', pro: '✓' },
      ],
    },
  ],
  ifiKicker: "O'sayotgan kompaniyalar uchun",
  ifiTitle: 'Jahon banki, ADB va BMT tenderlari',
  // {count}/{word} — sahifa data.ifiActive'dan qo'yadi, qattiq yozilgan son emas
  // (raqam yuqoridagi hisoblagichdan ajralib qolmasligi uchun).
  ifiBody:
    "{count} ta ochiq xalqaro {word}. Buyurtmachilar — O'zbekiston idoralari, mablag' — banklar va fondlardan, byudjetlar valyutada. Raqobat esa birja maydonchalaridagidan ancha past.",
  ifiCta: "XMI bo'limini ochish →",
  // XMI tender kartochkasi (maket landing-pro-uz.html:489–498).
  ifiIllustration: {
    kind: 'docs',
    status: 'Faol',
    left: '16 kun qoldi',
    title: "O'zbekistonda yaylovlarni boshqarish tizimlarini mustahkamlash",
    categories: ['Ilmiy tadqiqotlar', 'XMI'],
    rows: [
      { label: 'Moliyalashtirish', value: 'Jahon banki' },
      { label: 'Yopilish', value: '28-avgust 2026' },
    ],
    docs: [],
    steps: [],
  },
  pricingTitle: 'Tariflar',
  pricingLead:
    "Tenderlarni o'qish va tahlil qilish — bepul. Tarif buyurtmachi kontaktlari, hujjatlar va analitikani ochadi.",
  periodMonthly: 'Oy',
  periodYearly: 'Yil',
  periodYearlyBadge: '×2 foyda',
  // Отступление 11 (2026-08-20): YaTT tarifi plans[]dan butunlay olib
  // tashlandi — /start Pro va Biznesni sotadi, YaTT uchun alohida /ip sahifasi
  // bor. `ipCrossLinkText`/Label pastda qoladi (yagona /ip'ga o'tish) —
  // endi PricingThree ularni sarlavha ostida emas, butun tariflar
  // to'ri ostida chiqaradi (sections/pricing-three.tsx).
  plans: [
    {
      name: 'Pro',
      priceMonthly: "399 000 so'm/oy",
      priceYearly: "2 399 000 so'm/yil",
      wasYearly: '4 788 000',
      noteMonthly: "yoki 2 399 000 so'm/yil — yil 6 oy narxida",
      noteYearly: "yil 6 oy narxida — 2 389 000 so'm tejaysiz",
      features: [
        'Barcha buyurtmachi kontaktlari — cheksiz',
        'Har bir tender uchun TT va shartnoma',
        "Analitika: g'oliblar narxi va ishtirokchilar",
        'Jahon banki, ADB va BMT tenderlari',
        "Telegram-bot: bildirishnomalar, dayjestlar, TT bo'yicha javoblar",
        "Yutgan tenderlaringiz bo'yicha bildirishnomalar — o'zi sozlanadi",
        "Excel'ga yuklab olish",
      ],
      yearlyOnlyFeatures: ["Ustuvor qo'llab-quvvatlash — yillik obunada"],
      cta: "Pro'ni rasmiylashtirish",
      highlighted: true,
      flag: 'Ommabop',
      note: null,
    },
    {
      name: 'Biznes',
      priceMonthly: "699 000 so'm/oy",
      priceYearly: "4 199 000 so'm/yil",
      wasYearly: null,
      noteMonthly: "yoki 4 199 000 so'm/yil",
      noteYearly: "yillik to'lovda — ×2 foyda",
      features: [
        "Pro'dagi hamma narsa",
        "3 ta o'rin: siz va xodimlaringiz",
        "Har birida — o'z boti va o'z bildirishnomalari",
      ],
      yearlyOnlyFeatures: [],
      cta: 'Biznesni rasmiylashtirish',
      highlighted: false,
      flag: null,
      note: "Jamoalar uchun: ta'minot bo'yicha xodim kuzatadi, smetachi g'oliblar narxidan hisoblaydi, direktor butun manzarani ko'radi.",
    },
  ],
  // ipCrossLinkLabel — domenning inson o'qiydigan shakli, maketdagidek (bu
  // havola matni, href emas; `/ip` bare-yo'liga o'tishni komponent yig'adi).
  ipCrossLinkText: 'Endi boshlayapsizmi? Siz uchun alohida sahifa:',
  ipCrossLinkLabel: 'uztender.com/ip',
  payNote:
    "To'lov Payme orqali yoki hisob bo'yicha (yuridik shaxslar va YaTT uchun — yillik). Istalgan payt bekor qilish mumkin: to'langan muddat oxirigacha kirish ishlaydi.",
  teamTitle: 'Bu xizmat ortida kim turibdi',
  // Отступление 4: команда — две карточки (CEO + CTO), международные
  // сокращения без перевода, без официоза — фото крупнее (см. комментарий в
  // start.ru.ts). Отступление 6 (2026-08-18): `bio` abzatsi butunlay olib
  // tashlandi — kartochka endi faqat foto + ism + rol.
  team: [
    {
      name: 'Igor Kim',
      role: 'CEO',
      photo: '/img/team/igor.jpg',
      initials: 'IK',
      links: [
        { label: 'Telegramga yozing', href: 'https://t.me/flesteyto', primary: true },
        { label: 'support@uztender.com', href: 'mailto:support@uztender.com', primary: false },
      ],
    },
    {
      name: 'Konstantin Tsoy',
      role: 'CTO',
      photo: '/img/team/konstantin.jpg',
      initials: 'KT',
      links: [],
    },
  ],
  // Отступление 5: «IT Park rezidenti» не публикуем — формулировка не подтверждена.
  fineprint: [
    { label: '«FASTAGO» MChJ', href: null },
    { label: 'STIR 306377222', href: null },
    { label: 'Toshkent', href: null },
    { label: "To'liq rekvizitlar →", href: '/requisites' },
  ],
  faqTitle: "Ko'p beriladigan savollar",
  faq: [
    {
      q: "Katalog bepul-ku — nimaga pul to'layman?",
      a: "Katalog tender borligini ko'rsatadi. Pro esa uni yutish vositalarini beradi: buyurtmachi kontakti, TT va shartnoma, g'oliblar narxi va yangi tenderlar haqida birinchi bo'lib biladigan bildirishnomalar.",
    },
    {
      q: "Qaysi maydonchalarni yig'asizlar?",
      a: "O'zbekistonning rasmiy maydonchalari — xarid.uzex.uz, etender.uzex.uz, xt-xarid.uz va boshqalar. Bundan tashqari Jahon banki, ADB, UNGM, BMTTD va AIIB tenderlari. Katalog har 2 soatda yangilanadi.",
    },
    {
      q: 'Biznes kimga kerak?',
      a: "Ikki kishidan ortiq jamoalarga. Biznesda 3 ta o'rin bor, har birida o'z boti va o'z bildirishnomalari: yetkazib beruvchi, smetachi va direktor parallel ishlaydi.",
    },
    {
      q: 'Yillik obuna nima beradi?',
      a: "Yil — 6 oy narxida: Pro 4 788 000 o'rniga 2 399 000 so'm. Qo'shimcha ustuvor qo'llab-quvvatlash. Yuridik shaxslar va YaTT hisob bo'yicha to'lashi mumkin.",
    },
    {
      q: "Mening sohamda tender kam bo'lsa-chi?",
      a: "To'lovdan oldin tekshiring — katalog ochiq: 31 ta toifa, barcha 14 hudud. Topa olmasangiz — bizga yozing, birga ko'ramiz.",
    },
    {
      q: 'Obunani qanday bekor qilaman?',
      a: "Istalgan payt, shaxsiy kabinetda ikki klik bilan. To'langan muddat oxirigacha kirish ishlaydi, keyin pul yechilmaydi.",
    },
  ],
  // Отступление 9: «Bugun» → «bir haftada».
  finalH2: "Bir haftada katalogga {count} ta {word} qo'shildi",
  finalLead:
    "Ertaga yangilari chiqadi. Savol bitta: siz ular haqida e'lon kunida bilasizmi — yoki muddat o'tgandan keyin.",
  finalCtaPrimary: "Maydonchaga o'tish",
  footerLinks: [
    { label: 'Xizmat haqida', href: '/about' },
    { label: "Yetkazib beruvchilar uchun qo'llanma", href: '/guide' },
    { label: 'Tariflar', href: '/plans' },
    { label: 'Ommaviy oferta', href: '/offer' },
    { label: 'Maxfiylik', href: '/privacy' },
    { label: 'Rekvizitlar', href: '/requisites' },
    { label: '@flesteyto', href: 'https://t.me/flesteyto' },
    { label: '+998 90 187-77-98', href: 'tel:+998901877798' },
  ],
  footerLegal: '© 2026 «FASTAGO» MChJ. Barcha huquqlar himoyalangan. STIR: 306377222',
  stickyTitle: "Pro — oyiga 399 000 so'm",
  stickySubtitle: 'katalog — bepul',
  stickyCta: "Maydonchaga o'tish",
};
